<template>
  <div>
    <div class="edidemic-banner d-flex align-items-center justify-content-center bg-cover">
      <h2 class="h4 h2-md text-white bg-light-primary p-4 text-right">防疫交給 GoHome ，旅客安心入住<br>
        <span class="h5 d-none d-sm-inline">- 隔離安心，親人放心</span>
      </h2>
    </div>
    <div class="container">
      <section class="text-underline mt-3 mt-md-5">
        <h2 class="h4 h2-md">疫情補助對象及優惠</h2>
        <div class="row mt-3 mt-md-5">
          <div class="col-md-6">
            <h3 class="h5 h3-md">居家檢疫者</h3>
            <p class="text-left mt-3">
              <span class="h5 text-danger">防疫旅館</span>是給居家檢疫者使用，以台北市為例一共有70間，
              每家旅館補助的金額不盡相同，需查詢各家旅館補助方式(<a class="text-secondary" href="https://www.tpedoit.gov.taipei/News_Content.aspx?n=2512DE93E0C88F50&s=4D1A133CA1360666" target="blank">台北市防疫旅館名單</a>)，
              其中台北市政府與劍潭海外青年活動中心合作，提供一整棟 200 間房間的居家檢疫空間非防疫旅館，房價較低，每日收費 2200 元含每日三餐
              (<a class="text-secondary" href="http://quarantine-hotel.tpech.gov.tw/Search/SearchStep2?search_index=0" target="blank">安心檢疫所網站</a>)。
            </p>
          </div>
          <div class="col-md-6 mt-3 mt-md-0">
            <h3 class="h5 h3-md">居家檢疫者的家屬</h3>
            <p class="text-left mt-3">
              <span class="h5 text-danger">安心旅館</span>是給居家檢疫者的家屬使用，由於台北市防疫旅館不足，故鼓勵檢疫者留在家中，
              其餘家人可到外頭居住，設籍台北市者，同住家人入住台北市合法旅館 14 天，將補助<span class="font-weight-bold">「每位居家檢疫 / 居家隔離者 <span class="text-danger">7000</span> 元」</span>。
            </p>
          </div>
        </div>
      </section>
      <section class="application-allowance-process mt-3 mt-md-5">
        <h2 class="h4 h2-md mb-3 mb-md-5">補住申請流程</h2>
        <ul class="application-process text-left">
          <li class="mb-3" data-aos="fade-up">
            <h3 class="h5 h3-md text-primary my-3">Step 1 確認資格</h3>
            <ul>
              <li>需取得居家檢疫 / 居家隔離通知書。</li>
              <li>居家檢疫 / 居家隔離者須設籍台北市。</li>
              <li>在居家檢疫 / 居家隔離結束次日起 6 個月內，可以提出申請。</li>
            </ul>
          </li>
          <li class="mb-3" data-aos="fade-up">
            <h3 class="h5 h3-md text-primary my-3">Step 2 訂房入住</h3>
            <ul>
              <li>居家檢疫者 / 居家隔離者居住的家屬須於居家檢疫期間入住臺北市防疫旅館、檢疫所。</li>
              <li>入住日期須完全符合居家檢疫 / 居家隔離日期。</li>
              <li>需連續 14 天入住同一間旅館。</li>
            </ul>
          </li>
          <li class="mb-3" data-aos="fade-up">
            <h3 class="h5 h3-md text-primary my-3">Step 3 備妥文件</h3>
            <ul>
              <li>居家檢疫 / 居家隔離申請表（非網路申辦須檢附）。</li>
              <li>居家檢疫 / 居家隔離通知書影本。</li>
              <li>居家檢疫者 / 居家隔離者國民身分證正反面影本。</li>
              <li>居家檢疫者 / 居家隔離者或其法定代理人或監護人或同住親友金融機構存簿封面影本。</li>
              <li>入住合法旅館民宿證明文件（付款收據或發票等）影本。</li>
            </ul>
          </li>
          <li data-aos="fade-up">
            <h3 class="h5 h3-md text-primary my-3">Step 4 申請補助</h3>
            <ul>
              <li>申請人須為居家檢疫 / 居家隔離者本人，如為未成年人，應由其法定代理人代為申請</li>
              <li>網路申辦：於 <a class="text-secondary text-underline" href="https://service.gov.taipei/Case/ApplyWay/202003300005" target="blank">臺北市政府市民服務大平臺</a>
                填寫辦理，處理時限 30 天。</li>
              <li>郵寄申辦：於 <a class="text-secondary text-underline" href="https://service.gov.taipei/Case/ApplyWay/202003300007" target="blank">臺北市政府市民服務大平臺</a>
                下載申請表填寫，郵寄掛號至：110204 臺北市信義區市府路 1 號中央區 4 樓 觀光傳播局收，處理時限 60 天。</li>
            </ul>
          </li>
        </ul>
      </section>
      <section class="raised-discount mt-3 mt-md-5">
        <h2 class="h4 h2-md mb-3 mb-md-5">GoHome 額外加碼</h2>
        <p class="text-left text-danger font-weight-bold h6 h5-md">
          符合申請資格者，透過 GoHome 平台訂房，每房額外再補助 2000 元(一人限一次)。
        </p>
      </section>
      <section class="concept-clarification py-3 py-md-5">
        <h2 class="h4 h2-md mb-3 mb-md-5">防疫小知識</h2>
        <table class="table text-left">
          <thead>
            <tr class="bg-primary text-white">
              <th scope="col"></th>
              <th scope="col">自主健康管理</th>
              <th scope="col">居家檢疫</th>
              <th scope="col">居家隔離</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">對象</th>
              <td>
                <ul>
                  <li>居家隔離或檢疫期滿者</li>
                  <li>曾接受採檢，結果為陰性者</li>
                </ul>
              </td>
              <td>所有自外國入境者</td>
              <td>曾與確診個案接觸者</td>
            </tr>
            <tr>
              <th scope="row">負責單位</th>
              <td>無</td>
              <td>由里長負責，每日主動追蹤</td>
              <td>由地方衛生主管機關負責，每天主動追蹤2次</td>
            </tr>
            <tr>
              <th scope="row">是否可外出</th>
              <td>盡量避免外出，如外出須配戴口罩</td>
              <td class="text-danger">不可外出</td>
              <td class="text-danger">不可外出</td>
            </tr>
            <tr>
              <th scope="row">隔離時間</th>
              <td colspan="3" class="text-center">14天</td>
            </tr>
            <tr>
              <th scope="row">注意事項</th>
              <td>
                <ul>
                  <li>建議盡可能在家上班</li>
                  <li>避免出入公共場所</li>
                  <li>若出現不適症狀，應立即<span class="text-secondary">撥打1922</span></li>
                </ul>
              </td>
              <td colspan="2">
                <ul>
                  <li>避免與家人接觸及公共家中設施</li>
                  <li>每天詳實測量體溫，並確實回報健康狀況</li>
                  <li>若出現不適症狀，應由衛生主管機關安排就醫，勿自行前往</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th scope="row">罰款</th>
              <td>無</td>
              <td>可處 10 萬至 100 萬罰緩</td>
              <td>可處 20 萬至 100 萬罰緩</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
  },
  mounted () {
  }
}

</script>
<style lang='scss'>
.edidemic-banner{
    background-image: url("https://images.unsplash.com/photo-1572891086295-6c1c7c476549?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1300&q=80");
    height: 240px;
}
.bg-light-primary{
  background: rgba(31,28,63,0.8);
}
.application-process ul{
  list-style-type:circle;
  list-style-position: inside;
}
.concept-clarification ul{
  list-style-type:decimal;
  list-style-position: inside;
}
</style>
